/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var moment = require('moment');

var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function(individualId) {
  var deferred = $.Deferred();
  $.soap({
    body: {
      GetIndividualGeneralInformation: {
        $xmlns: 'http://dobs.pa.gov/nd/individual/bpm/1.0',
        IndividualID: individualId
      }
    },
    blueprintArrays: ['GetIndividualGeneralInformationResponse.ND_EntityOfficerAssociatedLicense'],
    blueprint: {
      individualType: '$..IndividualType',
      entityOfficerId: '$..EntityOfficerID',
      entityId: '$..EntityID',
      entityName: '$..EntityName',
      licenseId: '$..LicenseID',
      licenseNumber: '$..LicenseNumber',
      licenseType: '$..LicenseType',
      individualId: '$..IndividualID',
      firstName: '$..FirstName',
      middleName: '$..MiddleName',
      lastName: '$..LastName',
      title: '$..Title',
      CSFolderId: '$..CSFolderID',
      ssn: '$..SSN',
      dob: '$..DOB',
      ein: '$..EIN',
      homePhoneNumber: '$..HomePhoneNumber',
      officePhoneExt: '$..OfficePhoneExt',
      cellPhoneNumber: '$..CellPhoneNumber',
      email: '$..Email',
      addressLine1: '$..AddressLine1',
      addressLine2: '$..AddressLine2',
      addressLine3: '$..AddressLine3',
      city: '$..City',
      state: '$..State',
      postalCode: '$..PostalCode',
      country: '$..Country',
      officerType: '$..EntityOfficerTypeName',
      entityOfficerTypeId: '$..EntityOfficerTypeID',
      entityOfficerTypeName: '$..EntityOfficerTypeName',
      pspCheck: '$..PSPCheck',
      pspCheckCompletedDate: '$..PSPCheckCompletedDate',
      fbiCheck: '$..FBICheck',
      fbiDateCompleted: '$..FBIDateCompleted',
      nmlsIndividualId: '$..NMLSIndividualID',
      nmlsCheck: '$..NMLSCheck',
      nmlsDateCompleted: '$..NMLSDateCompleted',
      nonNmlsCheck: '$..NonNMLSCheck',
      nonNmlsDateCompleted: '$..NonNMLSDateCompleted',
      jnetReceived: '$..JNetReceived',
      jnetDateReceived: '$..JNetDateReceived',
      jnetComments: '$..JNetComments',
      flagged: '$..Flagged',
      hasActiveFlag: '$..HasActiveFlag',
      suffix: '$..Suffix',
      otherCheck: '$..OtherCheck',
      otherDateReceived: '$..OtherDateReceived',
      jnetType: '$..JNETType',
      jnetTypeName: '$..JNETTypeName',
      associatedLicenses: [
        '$..ND_EntityOfficerAssociatedLicense',
        {
          entityOfficerID: '$..EntityOfficerID',
          licenseNumber: '$..LicenseNumber',
          licenseType: '$..LicenseType',
          entityName: '$..EntityName',
          individualId: '$..IndividualID'
        }
      ]
    }
  })
    .done(function(response) {
      cleanUpResponse(response, {
        cleanUpTextKeys: true,
        cleanUpEmptyKeys: true
      });

      response.dob = response.dob ? moment(response.dob, 'YYYY-MM-DD').format('MM/DD/YYYY') : '';
      response.pspCheckCompletedDate = response.pspCheckCompletedDate
        ? moment(response.pspCheckCompletedDate, 'YYYY-MM-DD').format('MM/DD/YYYY')
        : '';
      response.fbiDateCompleted = response.fbiDateCompleted
        ? moment(response.fbiDateCompleted, 'YYYY-MM-DD').format('MM/DD/YYYY')
        : '';
      response.nmlsDateCompleted = response.nmlsDateCompleted
        ? moment(response.nmlsDateCompleted, 'YYYY-MM-DD').format('MM/DD/YYYY')
        : '';
      response.nonNmlsDateCompleted = response.nonNmlsDateCompleted
        ? moment(response.nonNmlsDateCompleted, 'YYYY-MM-DD').format('MM/DD/YYYY')
        : '';
      response.jnetDateReceived = response.jnetDateReceived
        ? moment(response.jnetDateReceived, 'YYYY-MM-DD').format('MM/DD/YYYY')
        : '';
      response.otherDateReceived = response.otherDateReceived
        ? moment(response.otherDateReceived, 'YYYY-MM-DD').format('MM/DD/YYYY')
        : '';

      response.pspCheck = response.pspCheck === '1';
      response.fbiCheck = response.fbiCheck === '1';
      response.isNMLSIndividual = !!response.nmlsIndividualId;
      response.nmlsCheck = response.nmlsCheck === '1';
      response.nonNmlsCheck = response.nonNmlsCheck === '1';
      response.jnetReceived = response.jnetReceived === '1';
      response.flagged = response.flagged === '1';
      response.hasActiveFlag = response.hasActiveFlag === '1';
      response.otherCheck = response.otherCheck === '1';

      deferred.resolve(response);
    })
    .fail(function(err) {
      deferred.reject();
    });

  return deferred.promise();
};
